export default __webpack_public_path__ + "static/0036-a9b59212b5932772e1f04c9a7e3660b9.png";